import script from "./TelemetryPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TelemetryPage.vue?vue&type=script&setup=true&lang=ts"

import "./TelemetryPage.vue?vue&type=style&index=0&id=37567af8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37567af8"]])

export default __exports__